var e = /* @__PURE__ */ ((t) => (t.tiktok = "tiktok", t.youtube = "youtube", t.instagram = "instagram", t.twitter = "twitter", t.facebook = "facebook", t.spotify = "spotify", t.linkedin = "linkedin", t.pinterest = "pinterest", t.snapchat = "snapchat", t.twitch = "twitch", t.discord = "discord", t.telegram = "telegram", t.vimeo = "vimeo", t.etsy = "etsy", t.email = "email", t.website = "website", t.whatsapp = "whatsapp", t))(e || {});
export {
  e as SocialLinksEnum
};
